/**
 * Cache Provider component that initializes and manages cache lifecycle
 * Should be wrapped inside AuthProvider to access authentication context
 */

import React from 'react';
import { useCacheInitialization, useCacheMonitoring } from '@/hooks/useCacheInitialization';
import { DEBUG_CONFIG } from '@/stores/cacheConfig';

interface CacheProviderProps {
  children: React.ReactNode;
}

export const CacheProvider: React.FC<CacheProviderProps> = ({ children }) => {
  const { isInitialized } = useCacheInitialization();
  const { logCacheStats } = useCacheMonitoring();

  // Log cache stats periodically in development
  React.useEffect(() => {
    if (DEBUG_CONFIG.enableDebug && isInitialized) {
      const interval = setInterval(() => {
        logCacheStats();
      }, 30000); // Log every 30 seconds in dev

      return () => clearInterval(interval);
    }
  }, [isInitialized, logCacheStats]);

  // You could add a loading state here if needed
  // For now, we'll just render children immediately since cache works in background

  return <>{children}</>;
};